import { createRoot } from "react-dom/client";
import { initFaro } from "./lib/faro";
import App from "./App.tsx";
import "./index.css";

// Initialize Grafana Faro tracing before React renders
initFaro();

createRoot(document.getElementById("root")!).render(<App />);
